import { showDeskToast } from "@/components/notifications/desk-toast";

import {
  openProposalDeepLink,
  proposalDeepLink,
  PROPOSAL_KIND_AUTO_FIRED,
  PROPOSAL_NOTIFICATION_CATEGORY,
} from "./portfolio-proposal.service";

/**
 * Live `portfolio_wave_propose` frame → the desk toast whose action opens
 * the card. The proposal lane carries no `severity`, so the generic
 * notification→alert path never toasts it; this is its one toast door.
 * Returns false for any other notification so the caller falls through.
 */
export function showPortfolioProposalToast(frame: Record<string, unknown>): boolean {
  // The live frame nests the row under `notification` (see getLiveNotification);
  // a bare row (REST replay, tests) is accepted as-is.
  const payload =
    frame.notification && typeof frame.notification === "object"
      ? (frame.notification as Record<string, unknown>)
      : frame;
  const extra = (payload.extra_data ?? payload.metadata) as Record<string, unknown> | undefined;
  if (!extra || extra.category !== PROPOSAL_NOTIFICATION_CATEGORY) return false;
  const groupId = Number(extra.group_id);
  const proposalId = Number(extra.proposal_id);
  if (!Number.isInteger(groupId) || !Number.isInteger(proposalId) || proposalId <= 0) return false;

  const href =
    typeof payload.action_url === "string" && payload.action_url.startsWith("/dashboard?")
      ? payload.action_url
      : proposalDeepLink(groupId, proposalId);
  const autoFired = extra.kind === PROPOSAL_KIND_AUTO_FIRED;
  const title = typeof payload.title === "string" ? payload.title : autoFired ? "Sigma fired a wave" : "Sigma proposes a wave";
  const description = typeof payload.message === "string" ? payload.message : undefined;

  showDeskToast({
    id: `desk-proposal-${proposalId}`,
    eyebrow: autoFired ? "Wave fired · auto-fire" : "Sigma proposes",
    tone: autoFired ? "mint" : "neutral",
    persona: "sigma",
    title,
    description,
    action: {
      label: autoFired ? "See the wave" : "Review wave",
      onClick: () => openProposalDeepLink(href),
    },
  });
  return true;
}
